import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CMPS_DIALOG_DATA, CmpsDialogRef } from '@cmps/ng-uikit';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import {
    ColumnConfigItem,
    Icon,
} from '../../frontline-winning/model/fl-winning.global.model';
import { WinningPercentageService } from '../core';
import { WpCommitmentDetail } from '../core/model/wp-commitment-detail.model';
import { SortOrder } from '../grid';

import { TranslationKeyMap } from './commitment-details.i18n';
import {
    CommitmentDetailsDialogService,
    mapper,
} from './commitment-details.service';
import { CommitmentDialogData } from './model/commitment-detail-dialog-data.model';

@Component({
    selector: 'cmps-commitment-details-trend-dialog',
    templateUrl: './commitment-details-dialog.component.html',
    host: {
        class: 'cmps-commitment-details-trend-dialog',
    },
})
export class CommitmentDetailsDialogComponent implements OnInit {
    public columns: Observable<ColumnConfigItem[]>;
    rawData: WpCommitmentDetail[];
    /** @private */
    _i18n = TranslationKeyMap;
    constructor(
        private readonly _router: Router,
        private readonly _wpService: WinningPercentageService,
        private readonly _commitmentService: CommitmentDetailsDialogService,
        /** @private */ readonly _dialogRef: CmpsDialogRef<
            CommitmentDetailsDialogComponent,
            void
        >,
        /** @private */ @Inject(CMPS_DIALOG_DATA)
        readonly _commitmentDialogData: CommitmentDialogData,
    ) {}

    ngOnInit(): void {
        this._commitmentService.initializeColumnConfig();
        this.columns = this._commitmentService._commitmentColumnConfig;
        const c = this._wpService.listCommitmentData(
            this._commitmentDialogData.userId,
            this._commitmentDialogData.dataRangeId,
            this._commitmentDialogData.evaluationRangeId,
        );
        const f = c.pipe(map(mapper)).subscribe((_data) => {
            this.rawData = _data;
            this.sortByMetric(SortOrder.ASC);
            this.sortByStartDate(SortOrder.ASC);
            this.sortByDirectReport(SortOrder.ASC);
            f.unsubscribe();
        });
    }

    toggle(icon: Icon, columns: ColumnConfigItem[]): void {
        let newstate = null;
        if (icon.action !== null) {
            newstate = this[icon.action](null, icon.actionParams);
        }

        if (icon?.state !== undefined) {
            columns.forEach((g) => {
                if (g.icon != null) {
                    g.icon.forEach((f) => {
                        if (newstate == null && f.defaultState != null) {
                            f.counter = f.defaultState;
                        } else {
                            f.counter = null;
                        }
                    });
                }
            });
            icon.state = !icon.state;
            icon.counter = newstate;
        }
    }

    /** @private */
    sortByDirectReport(force?: SortOrder): SortOrder {
        return this._commitmentService.sortBy(
            'directReportSort',
            force,
            this.rawData,
        );
    }

    /** @private */
    sortByStartDate(force?: SortOrder): SortOrder {
        return this._commitmentService.sortBy(
            'startDateSort',
            force,
            this.rawData,
        );
    }

    /** @private */
    sortByMetric(force?: SortOrder): SortOrder {
        return this._commitmentService.sortBy(
            'metricSort',
            force,
            this.rawData,
        );
    }

    /** @private */
    _onViewCommitmentClick(data: WpCommitmentDetail): void {
        const cmds = `coaching-detail/${data.performerId}/commitments/${data.commitmentId}`;
        this._dialogRef.close();
        void this._router.navigate([cmds]);
    }
}
